// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3qGcw","loaderOuter":"PageOverlayLoader_loaderOuter__3GaLT"};